import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterControls = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  totalEntries, 
  filteredCount 
}) => {
  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'Last 7 Days' },
    { value: 'month', label: 'Last 30 Days' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const symptomTypeOptions = [
    { value: 'all', label: 'All Symptoms' },
    { value: 'pain', label: 'Pain/Discomfort' },
    { value: 'tiredness', label: 'Extreme Tiredness' },
    { value: 'dizziness', label: 'Dizziness/Confusion' },
    { value: 'breathing', label: 'Breathing Changes' },
    { value: 'stomach', label: 'Stomach/Digestion Issues' },
    { value: 'head', label: 'Head/Vision Issues' },
    { value: 'muscle', label: 'Muscle/Joint Problems' },
    { value: 'fever', label: 'Fever/Temperature' },
    { value: 'mood', label: 'Mood/Behavior Changes' },
    { value: 'unexplainable', label: 'Something Unexplainable' }
  ];

  const severityOptions = [
    { value: 'all', label: 'All Severities' },
    { value: 'mild', label: 'Mild (1-3)' },
    { value: 'moderate', label: 'Moderate (4-6)' },
    { value: 'severe', label: 'Severe (7-10)' }
  ];

  const userTypeOptions = [
    { value: 'all', label: 'All User Types' },
    { value: 'child', label: 'Child' },
    { value: 'elderly', label: 'Elderly Adult' },
    { value: 'chronic', label: 'Long-term Condition' },
    { value: 'general', label: 'General Adult' }
  ];

  const hasActiveFilters = 
    filters?.dateRange !== 'all' || 
    filters?.symptomType !== 'all' || 
    filters?.severity !== 'all' || 
    filters?.userType !== 'all';

  return (
    <div className="bg-card rounded-xl border border-border shadow-therapeutic p-4 sm:p-6 space-y-4">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} strokeWidth={2} className="text-primary" />
          <h2 className="text-lg sm:text-xl font-heading font-semibold text-foreground">
            Filter Entries
          </h2>
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            className="text-muted-foreground hover:text-foreground"
          >
            Clear
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="Date Range"
          options={dateRangeOptions}
          value={filters?.dateRange}
          onChange={(value) => onFilterChange('dateRange', value)}
        />

        <Select
          label="Symptom Type"
          options={symptomTypeOptions}
          value={filters?.symptomType}
          onChange={(value) => onFilterChange('symptomType', value)}
          searchable
        />

        <Select
          label="Severity Level"
          options={severityOptions}
          value={filters?.severity}
          onChange={(value) => onFilterChange('severity', value)}
        />

        <Select
          label="User Type"
          options={userTypeOptions}
          value={filters?.userType}
          onChange={(value) => onFilterChange('userType', value)}
        />
      </div>
      <div className="flex items-center justify-between pt-2 border-t border-border">
        <p className="text-sm text-muted-foreground">
          Showing <span className="font-semibold text-foreground">{filteredCount}</span> of{' '}
          <span className="font-semibold text-foreground">{totalEntries}</span> entries
        </p>
        {hasActiveFilters && (
          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-primary/10 text-primary text-xs font-medium">
            <Icon name="Filter" size={12} strokeWidth={2} />
            Filters Active
          </span>
        )}
      </div>
    </div>
  );
};

export default FilterControls;